module.exports = __webpack_public_path__ + "img/search.5d82340f.svg";